// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sa-0";